import { useState as i, useEffect as o } from "react";
const a = (t) => {
  const [n, r] = i(!1);
  return o(() => {
    const e = () => {
      r(window.innerWidth < t);
    };
    return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
  }, [t]), n;
};
export {
  a as useBreakpointMatch
};
